<template>
  <div>
    <div class="page-title">
      {{ $t('data.refund_transaction') }}
    </div>
    <div class="page-container">

      <RefundTransDetails />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Data_Payin',
  components: {
    RefundTransDetails: () => import('./components/RefundTransDetails.vue')
  }
}
</script>

<style scoped>

</style>
